import { useEffect, useRef, useState } from "react"
import { PlusIcon } from "components/ui/icons/plus/PlusIcon"
import { TextArea } from "components/ui/inputs/TextArea"
import style from "./ElevationNote.module.scss"

const { wrapper, addButton, plusIcon, label, textarea } = style

type Props = {
	comment?: string
	onCommit?: (note: string) => void
}

export const ElevationNote = ({ comment = "", onCommit }: Props) => {
	const [isOpen, setIsOpen] = useState(comment.length > 0)
	const [note, setNote] = useState(comment)
	const savedRef = useRef(comment)

	useEffect(() => {
		savedRef.current = comment
		setNote(comment)
		setIsOpen(comment.length > 0)
	}, [comment])

	const handleBlur = () => {
		if (note === savedRef.current) return
		savedRef.current = note
		onCommit?.(note)
		if (note.length === 0) setIsOpen(false)
	}

	return (
		<div className={wrapper}>
			{isOpen ? (
				<>
					<span className={label}>Note</span>
					<TextArea
						className={textarea}
						placeholder=""
						minRows={3}
						value={note}
						onChange={(e) => setNote(e.target.value)}
						onBlur={handleBlur}
					/>
				</>
			) : (
				<button type="button" className={addButton} onClick={() => setIsOpen(true)}>
					<span className={plusIcon}>
						<PlusIcon />
					</span>
					Add note
				</button>
			)}
		</div>
	)
}
